// extracted by mini-css-extract-plugin
export var card = "_aa-0";
export var failedIcon = "_aa-4";
export var failedIconBadge = "_aa-3";
export var icon = "_aa-1";
export var successIcon = "_aa-2";